//region block: pre-declaration
//endregion
function segment(_this__u8e3s4, pos) {
  var i = binarySearch(_this__u8e3s4.h3x_1, pos + 1 | 0, 0, _this__u8e3s4.g3x_1.length);
  return i >= 0 ? i : ~i;
}
function binarySearch(_this__u8e3s4, value, fromIndex, toIndex) {
  var left = fromIndex;
  var right = toIndex - 1 | 0;
  while (left <= right) {
    var mid = (left + right | 0) >>> 1 | 0;
    var midVal = _this__u8e3s4[mid];
    if (midVal < value)
      left = mid + 1 | 0;
    else if (midVal > value)
      right = mid - 1 | 0;
    else
      return mid;
  }
  return (-left | 0) - 1 | 0;
}
//region block: exports
export {
  segment as segment35wobhh99hrhg,
};
//endregion

//# sourceMappingURL=SegmentedByteString.mjs.map
